import classNames from 'classnames';
import { DotColorEnum, TyChipSmall } from '@tymbe/ui-primitives'
import { JSX } from 'react';

type TyTimelineItemContentCardProps = {
  dotColor: DotColorEnum;
  title: string;
  note: string;
  action?: JSX.Element;
};

export const TyTimelineItemContentCard = ({
  dotColor,
  title,
  note,
  action,
}: TyTimelineItemContentCardProps) => {
  return (
    <div className="border-[1px] border-secondary-200 shadow-down-xs rounded-2xl overflow-clip relative flex-grow">
      <div
        className={`w-[5px] h-full ${classNames({
          'bg-red-600': dotColor === DotColorEnum.red,
          'bg-primary-400': dotColor === DotColorEnum.green,
        })} absolute left-0 top-0`}
      ></div>
      <div className="flex flex-row p-8">
        <div className="flex flex-col">
          <div className="flex flex-col">
            <TyChipSmall dotColor={dotColor}>Životy a bany</TyChipSmall>
            <div className="text-body-1-sm font-semibold mt-5">{title}</div>
            {note != null ? <div className="text-body-2-md">{note}</div> : null}
          </div>
        </div>
        <div className="mt-auto ml-auto flex flex-row items-center gap-2">
          {action}
        </div>
      </div>
    </div>
  );
};
